import html2canvas from "html2canvas";
import jsPDF from "jspdf";

/**
 * Custom hook to generate a PDF from a DOM element reference
 * @param {Object} options - Optional configuration for the PDF
 * @returns {Function} generatePdf - Function to generate PDF
 */
const GeneratePdf = (options = {}) => {
  // Destructure and set defaults for options
  const { filename = "document.pdf", scale = 2, imgType = "PNG", pdfFormat = "a4", pdfOrientation = "p" } = options;

  /**
   * Function to generate a PDF from a referenced DOM element
   * @param {Object} elementRef - Reference to the form or DOM element to capture
   */
  const generatePdf = async (elementRef) => {
    if (!elementRef || !elementRef.current) {
      console.error("Element reference is not provided or invalid.");
      return;
    }

    const element = elementRef.current;
    try {
      // Capture the element as a canvas
      const canvas = await html2canvas(element, {
        scale: scale,
        useCORS: true,
        backgroundColor: "#ffffff",
        removeContainer: true,
      });

      // Convert canvas to image data
      const imgData = canvas.toDataURL(`image/${imgType}`);
      const pdf = new jsPDF(pdfOrientation, "mm", pdfFormat); // PDF setup

      // Determine image width and height based on A4 dimensions
      const imgWidth = 210; // A4 width in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width; // Preserve aspect ratio
      let heightLeft = imgHeight;
      let position = 0;

      // Add image to PDF
      pdf.addImage(imgData, imgType, 0, position, imgWidth, imgHeight);

      heightLeft -= 297; // A4 height in mm

      // Add pages if content exceeds one page
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, imgType, 0, position, imgWidth, imgHeight);
        heightLeft -= 297;
      }

      // Save the PDF with the provided filename
      pdf.save(filename);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  return generatePdf;
};

export default GeneratePdf;
